import type { RootState } from 'features/app/store/rootReducer';

export const CALL_RESET_SLICE_KEYS = [
  'audio',
  'call',
  'callCaptions',
  'callDeaf',
  'callDetails',
  'callHearing',
  'callerSession',
  'coldHandoff',
  'conference',
  'customGreeting',
  'deafPhoneNumberHidden',
  'dialedNumbersHistory',
  'dialPad',
  'emergency',
  'reporting',
  'signMail',
  'stats',
  'teaming',
  'trainingForker',
  'vco',
  'videoPrivacy',
  'voiceSession',
  'vrsCall',
  'vrsChat',
  'vrsConferenceCall',
] as const satisfies readonly (keyof RootState)[];

export type CallResetSliceKey = (typeof CALL_RESET_SLICE_KEYS)[number];

type CallResetBoundarySliceConfig = {
  ignoredKeys?: readonly string[];
};

export const CALL_RESET_BOUNDARY_CONFIG: Record<
  CallResetSliceKey,
  CallResetBoundarySliceConfig
> = {
  audio: {},
  call: {
    ignoredKeys: ['lastCallId'],
  },
  callCaptions: {},
  callDeaf: {},
  callDetails: {},
  callHearing: {},
  callerSession: {
    ignoredKeys: ['isWaitingForCalls', 'status'],
  },
  coldHandoff: {},
  conference: {},
  customGreeting: {},
  deafPhoneNumberHidden: {},
  dialedNumbersHistory: {},
  dialPad: {
    ignoredKeys: ['autoLaunchDialPad'],
  },
  emergency: {
    ignoredKeys: ['phoneNumbers'],
  },
  reporting: {},
  signMail: {},
  stats: {},
  teaming: {},
  trainingForker: {
    ignoredKeys: ['enabled'],
  },
  vco: {},
  videoPrivacy: {},
  voiceSession: {},
  vrsCall: {},
  vrsChat: {},
  vrsConferenceCall: {},
};
